import { lang_CN } from "./lang/CN";
import { lang_EN } from "./lang/EN";

//中英文切换
export const getLang = (lang) => {
    if (lang === 'CN') {
        return lang_CN;
    } else {
        return lang_EN;
    }
}

//设置中英文
export const setLang = (lang) => {
    localStorage.setItem('lang', lang); 
    window.location.reload(); //刷新页面
}

//根据中英文切换导航栏
export const getLangName = (code) => {
    const lang = localStorage.getItem('lang') || 'CN';
    const langTxt = getLang(lang)
    return langTxt[code] || code; //如果没有对应的code就返回code
}